export const categorizedEntityKeys = {
  all: ["categorizedEntity"] as const,
  categorizedEntity: (categorizedEntityId: string | null) =>
    [...categorizedEntityKeys.all, categorizedEntityId] as const,
  project: (projectId: string | null, classification?: string | undefined, objectiveId?: string | undefined) =>
    [...categorizedEntityKeys.all, projectId, classification, objectiveId, "categorizedEntities"] as const,
  element: (elementId: string | null, elementName: string | null) =>
    [...categorizedEntityKeys.all, "elementCategorization", elementId, elementName] as const,
};
